var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellersRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-76.8 -76.8 665.60 665.60",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#000000;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.494,96.433c26.632,0,48.209-21.592,48.209-48.201C304.703,21.584,283.126,0,256.494,0 c-26.647,0-48.216,21.584-48.216,48.232C208.278,74.84,229.847,96.433,256.494,96.433z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.225,126.746l-64.731,64.731l-65.139-65.131c-14.756,9.176-26.412,25.91-26.412,41.718v162.059 c0,11.687,9.466,21.153,21.153,21.153c5.738,0,0,0,14.757,0l8.045,138.214c0,12.433,10.078,22.511,22.519,22.511 c5.236,0,14.92,0,24.583,0c9.67,0,19.34,0,24.591,0c12.432,0,22.503-10.078,22.503-22.511l8.052-138.214c14.757,0,9.003,0,14.757,0 c11.679,0,21.145-9.466,21.145-21.153V168.063C347.049,152.475,335.715,136,321.225,126.746z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "242.076,165.732 256.463,180.119 269.807,166.784 269.807,140.82 242.076,140.82 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.091,
    y: 113.787,
    className: "st0",
    width: 27.691,
    height: 17.747
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.711,149.084c23.28,0,42.102-18.854,42.102-42.11c0-23.256-18.822-42.11-42.102-42.11 c-23.249,0-42.094,18.853-42.094,42.11C366.617,130.231,385.462,149.084,408.711,149.084z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.065,171.784l-50.202,50.194l-33.123-33.123v141.267c0,13.586-5.62,25.815-14.614,34.669v6.852 l7.025,120.694c0,10.856,8.815,19.662,19.662,19.662c4.592,0,13.029,0,21.475,0c8.453,0,16.899,0,21.474,0 c10.863,0,19.662-8.806,19.662-19.662l7.025-120.694c12.889,0,7.873,0,12.889,0c10.204,0,18.468-8.265,18.468-18.484V211.641 C487.805,195.511,473.936,178.314,458.065,171.784z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "407.886,210.581 421.073,197.403 421.073,180.323 395.752,180.323 395.752,198.447 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.744,
    y: 160.23,
    className: "st0",
    width: 25.344,
    height: 11.648
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.289,149.084c23.249,0,42.094-18.854,42.094-42.11c0-23.256-18.845-42.11-42.094-42.11 c-23.28,0-42.102,18.853-42.102,42.11C61.187,130.231,80.009,149.084,103.289,149.084z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.26,188.855l-33.123,33.123l-50.202-50.194c-15.87,6.53-29.74,23.727-29.74,39.858v141.518 c0,10.22,8.265,18.484,18.468,18.484c5.015,0,0,0,12.888,0l7.026,120.694c0,10.856,8.798,19.662,19.661,19.662 c4.576,0,13.022,0,21.475,0c8.446,0,16.883,0,21.475,0c10.848,0,19.662-8.806,19.662-19.662l7.025-120.694v-6.852 c-8.994-8.854-14.614-21.083-14.614-34.669V188.855z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.113,210.581 116.248,198.447 116.248,180.323 90.927,180.323 90.927,197.403 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.911,
    y: 160.23,
    className: "st0",
    width: 25.345,
    height: 11.648
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellersRecord);
export default __webpack_public_path__ + "static/media/sellers_record.d4975161ca53d9691acc1403c1224e49.svg";
export { ForwardRef as ReactComponent };